import { Component, OnInit } from '@angular/core';
import packageJson from '../../../../../package.json';
import { DataTaskService } from '@app/core/services/data-task.service';
import { AppConfigService } from '@app/services/appconfig.service';

@Component({
    selector: 'tt-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.css'],
})
export class AboutComponent implements OnInit {
    public get?: AboutGet;

    public clientVersion = packageJson.version;

    public serverName?: string;

    constructor(private datatask: DataTaskService, private appConfig: AppConfigService) {
        this.serverName = appConfig.settings.serverName;
    }

    public forceReload() {
        // @ts-ignore
        window.location.reload(true);
    }

    private async loadGet() {
        this.get = (await this.datatask.Post(500, { url: window.location.href }))[0];
    }

    ngOnInit(): void {
        this.loadGet();
        //
    }
}

interface AboutGet {
    user_name: string;
    dbname: string;
    webversion_url: string;
    webversion_info: string;
    company_name: string;
    last_updated: string;
    last_updated_status: string;
    show_last_updated: '1' | '0';
    dbstation_tt_client_version: string;
}
